import CTYPE from 'constants/ctype.const';
import H from 'constants/httpMethod.const';
import logger from 'utils/logger.util';

const L = logger('prepareBody');

const prepareBody = (options) => {
  const { method, data, ctype } = options ?? {};

  // GET and HEAD aren't allowed by HTTP to have a body
  if (method === H.get || method === H.head) return {};

  // no need to check type if there's no data
  if (data === void 1) return {};

  if (CTYPE.json === ctype && typeof data !== 'undefined') return { body: JSON.stringify(data) };
  if (CTYPE.text === ctype && 'data' in options) return { body: String(data) };

  L.warn('prepareBody()', 'Unknown ctype:', ctype, 'not returning a body for data:', data);
  return {};
};

export default prepareBody;
